// @ts-check
/** @typedef {import('./types.js').LevelDefinition} Definition */
export const MEDALS = /** @type {const} */ (['speed', 'clean', 'collector']);
/** Optional Swift medal target, separate from the attempt countdown. @param {Definition} level */
export function targetTime(level) { return Math.ceil((level.finish - level.spawn) / 90 + (level.boss ? 40 : 15)); }
/** Generous exploration budget; each reboot receives a fresh countdown. @param {Definition} level */
export function timeLimit(level) { return Math.max(180, Math.ceil(targetTime(level) * 2 / 30) * 30); }
/** @param {Definition} level */
export function availableBits(level) { return level.solids.filter(s => s.kind === 'node' && (!s.reward || s.reward === 'bit')).length; }
/** @param {Definition} level */
export function availableMedals(level) { return MEDALS.filter(m => m !== 'collector' || availableBits(level) > 0); }
